import '../../resources/css/login/ApplyAccountForm.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {reduxForm, Field, getFormValues} from 'redux-form';
import { Row, Col, Button } from 'react-bootstrap';
import { commonRenderInput, commonRenderCheckbox } from '../../components/common/access-form';
import { doAddAccountApply, SAVE_SETTING_ACCOUNT_APPLY_SUCCESS, SAVE_SETTING_ACCOUNT_APPLY_FAIL } from '../../actions/settings/index';
import {
    verifyForm,
    minLength8,
    verifyAccount,
    maxLength60, maxLength128 /*, verifyPasswordConsistent, verifyNumber */
} from '../../components/common/access-form-validation';
// import moment from 'moment';
import { closeModal, popupModalConfirm, openModalAlert, openModalTip } from '../../actions/index';
import Loading from '../../components/common/Loading';
import { doCreateAccount } from '../../actions/login/index';
import {doActivePage} from "../../actions/menu";

// import Form from 'react-bootstrap/Form';

class ApplyAccountForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            pwdDisplay: false,
            pwdCfmDisplay: false,
        }
    };

    formSubmit = (values, action, props) => {
        const { popupModalConfirm, doAddAccountApply, openModalAlert /*, doCreateAccount */ } = this.props;
        let errLog = "";

        let objBody = {
            username: values["inputLoginEmail"],
            email: values["inputLoginEmail"],
            password: values["inputPassword"],
            passwordConfirmation: values["inputPasswordConfirm"],

            // firstName: values["firstName"],
            // lastName: values["lastName"],
            // email: values["email"],
            // phone: values["phone"],
            // jobTitle: values["jobTitle"],
            // company: values["company"],
            // city: values["city"],
            // region: values["region"],
            // systemIntegrator: values["systemIntegrator"] === 1,
            // internetProvider: values["internetProvider"] === 1
        };

        if (errLog) {
            openModalAlert(errLog);
        } else {
            popupModalConfirm('Confirm', 'icon-alert', 'Confirm to create account?', 300, () => doAddAccountApply(objBody), null, false);
        }
    }

    checkedCheckbox = () => {
        const { formValues, change, isReadonly } = this.props;
        if (!isReadonly) {
            const doCheck = !formValues['enabled'];
            change('enabled', doCheck);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { status, errMsg, openModalAlert, openModalTip, forwardLoginPage } = this.props;

        if (prevProps.status !== status) {
            // if menu chagne size(mode), need redraw table
            if (status === SAVE_SETTING_ACCOUNT_APPLY_SUCCESS) {
                openModalTip(
                    'Account has been created successfully.',
                    '',
                    forwardLoginPage
                )
            } else if (status === SAVE_SETTING_ACCOUNT_APPLY_FAIL && errMsg) {
                openModalAlert(errMsg);
            }
        }
    }

    render() {
        const { loading, handleSubmit, verifyFormPass /*, closeModal */ } = this.props;
        const { pwdDisplay, pwdCfmDisplay } = this.state;

        const pwdType = pwdDisplay ? 'text' : 'password';
        const classPwd = pwdDisplay ? 'icon-btn-password-show-n' : 'icon-btn-password-hide-n';
        const pwdCfmType = pwdCfmDisplay ? 'text' : 'password';
        const classCfmPwd = pwdCfmDisplay ? 'icon-btn-password-show-n' : 'icon-btn-password-hide-n';

        return (
            <div className='area-form form-custom'>
                <div className='apply-account-form'>
                    <form id="create-account-form" onSubmit={handleSubmit(this.formSubmit)}>
                        <div className='area-content area-divide-space'>
                            <div className='area-body'>
                                <Row>
                                    {/*<Col sm={12}>*/}
                                    {/*    <div className='area-form-label'>*/}
                                    {/*        <label className='need-star-label'></label><label>Username</label>*/}
                                    {/*    </div>*/}
                                    {/*    <div className='area-form-field'>*/}
                                    {/*        <Field name='inputUsername' type="text" component={commonRenderInput} placeholder="Please input your username" />*/}
                                    {/*    </div>*/}
                                    {/*</Col>*/}
                                    <Col sm={12}>
                                        <div className='area-form-label'>
                                            <label className='need-star-label'></label><label>Email</label>
                                        </div>
                                        <div className='area-form-field'>
                                            <Field id="create-account-form-email" name='inputLoginEmail' type="text" component={commonRenderInput} placeholder="Please input your email address" validate={[verifyAccount, maxLength60]} />
                                        </div>
                                    </Col>
                                    <Col sm={12}>
                                        <div className='area-form-label'>
                                            <label className='need-star-label'></label><label>Password</label>
                                        </div>
                                    </Col>

                                    <Col sm={11}>
                                        <div className='area-form-field'>
                                            <Field id="create-account-form-password" name="inputPassword" type={pwdType} component={commonRenderInput} placeholder="Please input password" validate={[minLength8, maxLength128]} />
                                        </div>
                                    </Col>
                                    <Col sm={1}>
                                        <div className='area-form-icon' style={{paddingLeft: '10px'}}><span className={classPwd} onClick={() => this.toggleField('pwdDisplay')}></span></div>
                                    </Col>

                                    <Col sm={12}>
                                        <div className='area-form-label'>
                                            <label className='need-star-label'></label><label>Confirm Password</label>
                                        </div>
                                    </Col>

                                    <Col sm={11}>
                                        <div className='area-form-field'>
                                            <Field id="create-account-form-confirm" name="inputPasswordConfirm" type={pwdCfmType} component={commonRenderInput} placeholder="Please input password again" validate={this.validateConfirmationPassword}/>
                                        </div>
                                    </Col>

                                    <Col sm={1}>
                                        <div className='area-form-icon' style={{paddingLeft: '10px'}}><span className={classCfmPwd} onClick={() => this.toggleField('pwdCfmDisplay')}></span></div>
                                    </Col>

                                    <Col sm={12}>
                                        {/* <div className='area-form-label'>
                                            <label className='need-star-label'></label><label>Enable</label>
                                        </div> */}
                                        <div>
                                            <Field
                                                id="create-account-form-checkbox"
                                                className='checkbox'
                                                   label="By creating this account, you agree to Prism’s Terms of Service and Privacy Policy."
                                                   name="enabled" component={commonRenderCheckbox}
                                                   customStyle='detail-form-switch detail-form-switch-info'
                                                   callback={this.checkedCheckbox}
                                                   validate={[this.requiredCheckbox]}
                                            />
                                            {/* <Form.Check.Label className='agreement-word'>{`By creating this account, you agree to Prism’s Terms of Service and Privacy Policy.`}</Form.Check.Label> */}
                                            {/* <span className='agreement-word'>By creating this account, you agree to Prism’s Terms of Service and Privacy Policy.</span> */}
                                        </div>
                                    </Col>
                                    <Col sm={12}>
                                        <div className='area-btn-signup'>
                                            <Button id="create-account-form-button-create" type="submit" variant="primary" size="lg" disabled={!verifyFormPass} block>
                                                <span>Create account</span>
                                            </Button>
                                        </div>
                                    </Col>
                                    {/*<div className="or-signup-social-word-left-line"></div>*/}
                                    {/*<span className='or-signup-social-word'>Or sign up with social</span>*/}
                                    {/*<div className="or-signup-social-word-right-line"></div>*/}
                                    {/*<span className='btn-google-n' onClick={this.applyAccount}></span>*/}
                                    {/*<span className='btn-fb-n' onClick={this.applyAccount}></span>*/}
                                    {/* <Col sm={6} >
                                        <div className='area-form-label'>
                                            <label className='need-star-label'>*</label><label>First Name</label>
                                        </div>
                                        <div className='area-form-field'>
                                            <Field name='firstName' type="text" component={commonRenderInput} placeholder="Input here" />
                                        </div>
                                    </Col> */}
                                    {/* <Col sm={6} >
                                        <div className='area-form-label'>
                                            <label className='need-star-label'>*</label><label>Last Name</label>
                                        </div>
                                        <div className='area-form-field'>
                                            <Field name='lastName' type="text" component={commonRenderInput} placeholder="Input here" />
                                        </div>
                                    </Col> */}
                                    {/* <Col sm={6} >
                                        <div className='area-form-label'>
                                            <label className='need-star-label'>*</label><label>Business Email</label>
                                        </div>
                                        <div className='area-form-field'>
                                            <Field name='email' type="text" component={commonRenderInput} placeholder="Input here" />
                                        </div>
                                    </Col> */}
                                    {/* <Col sm={6} >
                                        <div className='area-form-label'>
                                            <label className='need-star-label'>*</label><label>Phone Number</label>
                                        </div>
                                        <div className='area-form-field'>
                                            <Field name='phone' type="text" component={commonRenderInput} placeholder="Input here" validate={verifyNumber} />
                                        </div>
                                    </Col> */}
                                    {/* <Col sm={6} >
                                        <div className='area-form-label'>
                                            <label className='need-star-label'>*</label><label>Company</label>
                                        </div>
                                        <div className='area-form-field'>
                                            <Field name='company' type="text" component={commonRenderInput} placeholder="Input here" />
                                        </div>
                                    </Col> */}
                                    {/* <Col sm={6} >
                                        <div className='area-form-label'>
                                            <label className='need-star-label'>*</label><label>Job Title</label>
                                        </div>
                                        <div className='area-form-field'>
                                            <Field name='jobTitle' type="text" component={commonRenderInput} placeholder="Input here" />
                                        </div>
                                    </Col> */}
                                    {/* <Col sm={6} >
                                        <div className='area-form-label'>
                                            <label className='need-star-label'>*</label><label>Country/Region</label>
                                        </div>
                                        <div className='area-form-field'>
                                            <Field name='region' type="text" component={commonRenderInput} placeholder="Input here" />
                                        </div>
                                    </Col> */}
                                    {/* <Col sm={6} >
                                        <div className='area-form-label'>
                                            <label className='need-star-label'>*</label><label>City</label>
                                        </div>
                                        <div className='area-form-field'>
                                            <Field name='city' type="text" component={commonRenderInput} placeholder="Input here" />
                                        </div>
                                    </Col> */}
                                    {/* <Col sm={6} >
                                        <div className='area-form-label'>
                                            <label className='need-star-label'></label><label>System Integrator</label>
                                        </div>
                                        <div className='area-form-field'>
                                            <Field name='systemIntegrator' type="text" component={commonRenderCheckbox} callback={() => this.checkedCheckbox('systemIntegrator')} />
                                        </div>
                                    </Col> */}
                                    {/* <Col sm={6} >
                                        <div className='area-form-label'>
                                            <label className='need-star-label'></label><label>Internet service provider</label>
                                        </div>
                                        <div className='area-form-field'>
                                            <Field name='internetProvider' type="text" component={commonRenderCheckbox} callback={() => this.checkedCheckbox('internetProvider')} />
                                        </div>
                                    </Col> */}
                                </Row>
                            </div>
                        </div>
                        {/* <div className={'area-btns'}>
                            <Row>
                                <Col sm={4}>
                                    <div className='area-btn-cancel'>
                                        <Button type="button" variant="primary" size="lg" onClick={() => closeModal(null)} block>
                                            <span>Cancel</span>
                                        </Button>
                                    </div>
                                </Col>
                                <Col sm={8}>
                                    <div className='area-btn-save'>
                                        <Button type="submit" variant="primary" size="lg" block>
                                            <span>Save</span>
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </div> */}
                    </form>
                </div>
                <Loading loading={loading} center={true}></Loading>
            </div>
        )
    }

    validateConfirmationPassword = (value, form) => {
        if (value !== form.inputPassword) {
            return 'Passwords do not match';
        }
        return undefined;
    };

    requiredCheckbox = (value, form) => (value === 1 ? undefined : '');

    toggleField = (fieldName) => {
        this.setState({
            [fieldName]: !this.state[fieldName]
        })
    }
}

const mapStateToProps = (state, ownProps) => {
    let verifyFormPass = verifyForm(state.form['ApplyAccountForm']);

    let ret = {
        ...ownProps,
        loading: state.settingsReducers.loading,
        status: state.settingsReducers.status,
        errMsg: state.settingsReducers.errMsg,
        initialValues: {},
        verifyFormPass: verifyFormPass,
        formValues: getFormValues('ApplyAccountForm')(state)
    }

    return ret;
}

ApplyAccountForm = reduxForm({
    form: 'ApplyAccountForm',  // a unique identifier for this form
})(ApplyAccountForm)

export default connect(
    mapStateToProps,
    {
        closeModal, popupModalConfirm, doAddAccountApply, openModalAlert, doCreateAccount, openModalTip,
        doActivePage
    }
)(ApplyAccountForm)